import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Box,
  Button,
  Grid,
} from '@mui/material';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import type { Service } from '../../types';
import { getServices } from '../../services/api';
import { useLanguage } from '../../contexts/LanguageContext';

interface SuccessStepProps {
  barberId: number;
  serviceId: number;
  date: string;
  time: string;
  onNewBooking: () => void;
}

const SuccessStep: React.FC<SuccessStepProps> = ({
  barberId,
  serviceId,
  date,
  time,
  onNewBooking,
}) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [service, setService] = useState<Service | null>(null);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const services = await getServices();
        const selectedService = services.find(s => s.id === serviceId);
        if (selectedService) {
          setService(selectedService);
        }
      } catch (error) {
        console.error('Error fetching service:', error);
      }
    };

    fetchService();
  }, [serviceId]);

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom color="success.main">
        {t('success.title')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>
            <strong>{t('confirm.service')}:</strong> {service ? service.name : t('app.loading')}
          </Typography>
          <Typography>
            <strong>{t('confirm.date')}:</strong> {format(new Date(date), 'MMMM d, yyyy')}
          </Typography>
          <Typography>
            <strong>{t('confirm.time')}:</strong> {time}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/client')}
            >
              {t('success.viewAppointments')}
            </Button>
            <Button
              variant="outlined"
              onClick={onNewBooking}
            >
              {t('button.bookAnother')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SuccessStep; 